module.exports = __webpack_public_path__ + "media/AUDIO 06.4610f1b8.mp3";